// extracted by mini-css-extract-plugin
export default {"textInputWithPageSelection":"TextInputWithPageSelection_textInputWithPageSelection__-wUCY","openText":"TextInputWithPageSelection_openText__H1q9w"};